import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_women_all: FaireCategoryEntity = {
  token: "cat_women-all",
  type: "category",
  name: "All women",
  level: 3,
  parentToken: "cat_apparel-women",
  href: "/category/women",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
